<template>
  <div>
      <Vue2OrgTree
      ref="elementRef"
      :data="menuList"
      :props='propsObj'
      :horizontal="horizontal"
      :collapsable="collapsable"
      :label-class-name="labelClassName"
      :render-content="renderContent"
      @on-expand="onExpand"
      @on-node-click="onNodeClick"
    >
    </Vue2OrgTree>
    <div class="bottomBtn">
      <Button :disabled="!selectedObject.menuId" type="success" @click="addMenu()" icon="md-add">追加</Button>
      <Button :disabled="!selectedObject.menuId" type="primary" @click="editMenu()" icon="md-create" style="margin-left: 15px">编辑</Button>
      <Button :disabled="!selectedObject.menuId" type="error" @click="deleteMenu()" icon="ios-trash" style="margin-left: 15px">删除</Button>
    </div>


    <Modal
        v-model="modalShow"
        :title="addMenuState?'菜单信息维护（追加）':'菜单信息维护（编辑）'"
        width="800px"
      >
        <Form label-position="right" :model="formItem" :label-width="100" ref="formValidate" :rules="ruleValidate">
            <Row >
              <Col span="12">
                <FormItem label="菜单ID:" prop="menuId">
                <Input  v-model="formItem.menuId" ></Input>
                </FormItem>
              </Col>
              <Col span="11" offset="1">
                <FormItem label="菜单名称:"  prop="menuName">
                <Input  v-model="formItem.menuName" ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row >
              <Col span="12">
                <FormItem label="菜单类型:" prop="menuType">
                <Select v-model="formItem.menuType">
                    <Option v-for="(item,index) in CDList" :value="item.value" :key="index">{{ item.label }}</Option>
                </Select>
                </FormItem>
              </Col>
              <Col span="11" offset="1">
                <FormItem label="菜单图标:"  prop="icon">
                <Input  v-model="formItem.icon" ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row >
              <Col span="12">
                <FormItem label="页面组ID:" prop="groupId">
                <Select v-model="formItem.groupId" >
                    <Option v-for="item in pageGroupList" :value="item.groupId" :key="item.groupId">{{ item.groupName }}</Option>
                </Select>
                </FormItem>
              </Col>
              <Col span="11" offset="1">
                <FormItem label="页面ID:"  prop="pageId">
                <Input  v-model="formItem.pageId" ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row >
              <Col span="12">
                <FormItem label="权限类型:" prop="authType">
                <Input  v-model="formItem.authType" ></Input>
                </FormItem>
              </Col>
              <Col span="11" offset="1">
                <FormItem label="权限值:"  prop="authValue">
                <Input  v-model="formItem.authValue" ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row >
              <Col span="12">
                <FormItem label="提取子菜单:" prop="extractFlg">
                <Checkbox v-model="formItem.extractFlg"></Checkbox>
                </FormItem>
              </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="text" @click="cancle()">取消</Button> 
            <Button type="text" @click="save()">确认</Button>           
        </div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import CommonUtil from "../../util/CommonUtil";
import ModelUtil from "../../util/ModelUtil";

export default {
  name: "OrgTreeComponent",
  data: function() {
    return {
      treeStatus: {},
      menuList:{},
      propsObj:{label: "menuName", children:"menuBasicInfoList",expand: "expand"},
      horizontal: true,
      collapsable: true,
      expandAll: false,
      labelClassNameWhite: "bg-white",
      selectedClassName:"bg-orange",
      selectedObject:{},
      addMenuState:false,
      modalShow:false,
      formItem:{
        menuId:'',
        menuName:'',
        menuType:'',
        parentId:'',
        pageId:'',
      },
      treeStatus: {},
      CDList:[
        {value:'0',label:'页面'},
        {value:'1',label:'外部链接'}
      ],
      pageGroupList:[],
      ruleValidate: {
          menuId: [
              { required: true, message: '请填写菜单ID', trigger: 'blur' }
          ],
          menuName: [
              { required: true, message: '请填写菜单名称', trigger: 'blur' },
          ],
          menuType: [
              { required: true, message: '请选择菜单类型', trigger: 'change' }
          ],
          // groupId: [
          //     { required: true, message: '请选择页面组ID', trigger: 'change' }
          // ],
          // pageId: [
          //     { required: true,  message: '请填写页面ID', trigger: 'blur' },
          // ]
      }
    };
  },
  mounted: function() {
    this.getData()
    this.getMenuGroupInfo()
    // 保存控件实例
    // CommonUtil.saveElementToStore(this);
  },
  methods: {
    getData(){
      let obj=[{"type":"P00","stringData1":"D38D365112F8D91C125E4D3809053EB7","stringData2":"56CEB60557E4058A","stringData3":"1","objData1":{},"objData3":{"currentColumnId":"menu_id","parentColumnId":"parent_id"}},{"type":"P00","stringData1":"D38D365112F8D91C125E4D3809053EB7","stringData2":"56CEB60557E4058A","stringData3":"2","objData1":{},"objData3":{}}]
      axios.post("/menu/selectAllMenuInfo", {}).then((res) => {
          if(res){
            this.menuList=res[0]
            this.toggleExpand(this.menuList, this.expandAll);
            this.loadExpand(this.menuList)
          } 
      }).catch(err => {
          this.$Message.info(err);
      })
    },
    addMenu(){
      if(this.selectedObject.parentId){
        if(this.selectedObject.parentId==='S0'){
          this.selectedObject.relationType='1'
        }else if(this.selectedObject.parentId.includes("S0") && this.selectedObject.parentId.length>2){
          this.selectedObject.relationType='2'
        }
      }
      this.formItem.relationType=this.selectedObject.relationType
      this.formItem.parentId=this.selectedObject.menuId

      this.addMenuState=true
      this.modalShow=true
    },
    editMenu(){
      if(this.selectedObject.parentId){
        if(this.selectedObject.parentId==='S0C'){
          this.selectedObject.relationType='1'
        }else if(this.selectedObject.parentId.includes("S0C") && this.selectedObject.parentId.length>3){
          this.selectedObject.relationType='2'
        }
      }
      this.formItem=JSON.parse(JSON.stringify(this.selectedObject))
      this.modalShow=true
      this.addMenuState=false
    },
    deleteMenu(){
      if(this.selectedObject.menuBasicInfoList&&this.selectedObject.menuBasicInfoList.length!=0){
        this.$Message.error('请先删除子菜单');
        return
      }
      this.$Modal.confirm({
          title: this.$notice('deletion'),
          content: "",
          onOk: () => {
              axios.post("/menu/deleteMenuInfo", {menuId:this.selectedObject.menuId}).then((res) => {
                  if(res){
                    this.$Message.info(res);
                    this.saveExpand(this.menuList)
                    this.getData()
                  } 
                }).catch(err => {
                    this.$Message.info(err);
                })
          },
          onCancel: () => {},
      });
    },
    save(){
      // this.treeStatus=JSON.parse(JSON.stringify(this.menuList))
      this.$refs.formValidate.validate((valid) => {
          if (valid) {
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                content: "",
                onOk: () => {
                    if(this.addMenuState){
                      axios.post("/menu/insertMenuInfo", this.formItem).then((res) => {
                        if(res){
                          this.$Message.info(res);
                          this.modalShow=false
                          this.saveExpand(this.menuList)
                          this.getData()
                          this.$refs.formValidate.resetFields();
                        } 
                      }).catch(err => {
                          this.$Message.info(err);
                      })
                    }else{
                      axios.post("/menu/updateMenuInfo", this.formItem).then((res) => {
                        if(res){
                          this.$Message.info(res);
                          this.modalShow=false
                          this.saveExpand(this.menuList)
                          this.getData()
                          this.$refs.formValidate.resetFields();
                        } 
                      }).catch(err => {
                          this.$Message.info(err);
                      })
                    }
                },
                onCancel: () => {},
            });
          } else {
              // this.$Message.error('请填写');
          }
      })
      
      
    },
    getMenuGroupInfo(){
      axios.post("/menu/selectMenuGroupInfo", {}).then((res) => {
          if(res){
            this.pageGroupList=res
          } 
      })
    },
    cancle(){
      this.$refs.formValidate.resetFields();
      this.modalShow=false
    },
    renderContent(h, data) {
      return data.menuName;
    },
    labelClassName: function(data) {
      if (data == this.selectedObject) {
        return this.selectedClassName;
      } else {
        return this.labelClassNameWhite;
      }
    },
    onExpand(e, data) {
      this.selectedObject=data
      
      if ("expand" in data) {
        data.expand = !data.expand;
        if (!data.expand && data.menuBasicInfoList) {
          this.collapse(data.menuBasicInfoList);
        }
      } else {
        this.$set(data, "expand", true);
      }
    },
    //点击选项执行的方法，可以用于跳转到其他链接，注意一定要写协议头
    onNodeClick(e, data) {
      this.selectedObject=data
       //console.log(data.label);
       if(data.url==null){
        return false
      }else{
        window.open(data.url)
      }
    },
    collapse(list) {
      var _this = this;
      list.forEach(function(child) {
        if (child.expand) {
          child.expand = false;
        }
        child.menuBasicInfoList && _this.collapse(child.menuBasicInfoList);
      });
    },
    expandChange() {
      this.toggleExpand(this.data, this.expandAll);
    },
    toggleExpand(data, val) {
      var _this = this;
      if (Array.isArray(data)) {
        data.forEach(function(item) {
          _this.$set(item, "expand", val);
          if (item.menuBasicInfoList) {
            _this.toggleExpand(item.menuBasicInfoList, val);
          }
        });
      } else {
        this.$set(data, "expand", val);
        if (data.menuBasicInfoList) {
          _this.toggleExpand(data.menuBasicInfoList, val);
        }
      }
    },
    saveExpand: function(srcObj) {
      this.treeStatus[srcObj['menuId']] = srcObj[this.propsObj.expand];
      if (srcObj[this.propsObj.children]) {
        for (let i=0;i<srcObj[this.propsObj.children].length;i++) {
          this.saveExpand(srcObj[this.propsObj.children][i]);
        }
      }
    },
    loadExpand: function(srcObj) {
      srcObj['expand'] = this.treeStatus[srcObj['menuId']];
      // console.log(this.treeStatus[srcObj['menuId']])
      if (srcObj['menuBasicInfoList']) {
        for (let i=0;i<srcObj['menuBasicInfoList'].length;i++) {
          this.loadExpand(srcObj['menuBasicInfoList'][i]);
        }
      }
    },
  }
};
</script>

<style scoped>
/deep/ .bg-white {
  background-color: white;
  cursor: pointer;
}
/deep/ .bg-orange {
  background-color: orange;
  cursor: default;
}
.bg-orange {
  background-color: orange;
  cursor: default;
}
</style>
<style lang="less">
.org-tree-container {
  display: inline-block;
  padding: 15px;
  background-color: #fff;
}

.org-tree {
  // display: inline-block;
  display: table;
  text-align: center;

  &:before, &:after {
    content: '';
    display: table;
  }

  &:after {
    clear: both;
  }
}

.org-tree-node,
.org-tree-node-children {
  position: relative;
  margin: 0;
  padding: 0;
  list-style-type: none;

  &:before, &:after {
    transition: all .35s;
  }
}
.org-tree-node-label {
  position: relative;
  display: inline-block;

  .org-tree-node-label-inner {
    padding: 10px 15px;
    text-align: center;
    border-radius: 3px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, .15);
  }
}
.org-tree-node-btn {
  position: absolute;
  top: 100%;
  left: 50%;
  width: 20px;
  height: 20px;
  z-index: 10;
  margin-left: -11px;
  margin-top: 9px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  box-shadow: 0 0 2px rgba(0, 0, 0, .15);
  cursor: pointer;
  transition: all .35s ease;

  &:hover {
    background-color: #e7e8e9;
    transform: scale(1.15);
  }

  &:before, &:after {
    content: '';
    position: absolute;
  }

  &:before {
    top: 50%;
    left: 4px;
    right: 4px;
    height: 0;
    border-top: 1px solid #ccc;
  }

  &:after {
    top: 4px;
    left: 50%;
    bottom: 4px;
    width: 0;
    border-left: 1px solid #ccc;
  }

  &.expanded:after {
    border: none;
  }
}
.org-tree-node {
  padding-top: 20px;
  display: table-cell;
  vertical-align: top;

  &.is-leaf, &.collapsed {
    padding-left: 10px;
    padding-right: 10px;
  }

  &:before, &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 19px;
  }

  &:after {
    left: 50%;
    border-left: 1px solid #ddd;
  }

  &:not(:first-child):before,
  &:not(:last-child):after {
    border-top: 1px solid #ddd;
  }

}
.collapsable .org-tree-node.collapsed {
  padding-bottom: 30px;

  .org-tree-node-label:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    width: 50%;
    height: 20px;
    border-right: 1px solid #ddd;
  }
}
.org-tree > .org-tree-node {
  padding-top: 0;

  &:after {
    border-left: 0;
  }
}
.org-tree-node-children {
  padding-top: 20px;
  display: table;
  width: 100%;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 20px;
    border-left: 1px solid #ddd;
  }

  &:after {
    content: '';
    display: table;
    clear: both;
  }
}

.horizontal {
  .org-tree-node {
    // display: flex;
    // flex-direction: row;
    // justify-content: flex-start;
    // align-items: center;
    display: table-cell;
    float: none;
    padding-top: 0;
    padding-left: 20px;

    &.is-leaf, &.collapsed {
      padding-top: 10px;
      padding-bottom: 10px;
    }

    &:before, &:after {
      width: 19px;
      height: 50%;
    }

    &:after {
      top: 50%;
      left: 0;
      border-left: 0;
    }

    &:only-child:before {
      top: 1px;
      border-bottom: 1px solid #ddd;
    }

    &:not(:first-child):before,
    &:not(:last-child):after {
      border-top: 0;
      border-left: 1px solid #ddd;
    }

    &:not(:only-child):after {
      border-top: 1px solid #ddd;
    }

    .org-tree-node-inner {
      display: table;
    }

  }

  .org-tree-node-label {
    display: table-cell;
    vertical-align: middle;
  }

  &.collapsable .org-tree-node.collapsed {
    padding-right: 30px;

    .org-tree-node-label:after {
      top: 0;
      left: 100%;
      width: 20px;
      height: 50%;
      border-right: 0;
      border-bottom: 1px solid #ddd;
    }
  }

  .org-tree-node-btn {
    top: 50%;
    left: 100%;
    margin-top: -11px;
    margin-left: 9px;
  }

  & > .org-tree-node:only-child:before {
    border-bottom: 0;
  }

  .org-tree-node-children {
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: flex-start;
    display: table-cell;
    padding-top: 0;
    padding-left: 20px;
    width: auto;

    &:before {
      top: 50%;
      left: 0;
      width: 20px;
      height: 0;
      border-left: 0;
      border-top: 1px solid #ddd;
    }

    &:after {
      display: none;
    }

    & > .org-tree-node {
      display: block;
    }
  }
}
  .bottomBtn {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
  }
</style>


// WEBPACK FOOTER //
// src/components/site/MenuPageInfo.vue